import { CircularProgress, Box, Backdrop } from '@mui/material'
import { useLoading } from '../../context/loading-context'

const FullPageLoadingOverlay = () => {
  const { loading } = useLoading()
  return (
    <Backdrop
      open={loading}
      sx={{
        zIndex: theme => theme.zIndex.modal + 1,
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.2)', // Transparente pero bloquea clics
        backdropFilter: 'blur(2px)', // Opcional: desenfoque
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="inherit" />
      </Box>
    </Backdrop>
  )
}

export default FullPageLoadingOverlay
